"use client";

import { c as _c } from "react/compiler-runtime";
import type { PersonalizedViewProps } from "@/app/_components/LivePersonalizedEntry";
import { PersonalizedEntry } from "@/app/_components/PersonalizedEntry";
import { mapCtaExperiences } from "@/lib/ninetailed/mapCtaExperiences";
import CTAButton, { type CtaButtonEntry, type CtaExperiences } from "./CTAButton";
import { CTAButtonView, type CtaFields } from "./CTAButtonView";
interface Props {
  entry: CtaButtonEntry;
  experiences?: CtaExperiences;
  exposures: Record<string, number>;
  className?: string;
}
export function PersonalizedCtaButton(t0) {
  const $ = _c(16);
  const {
    entry,
    experiences,
    exposures,
    className
  } = t0;
  const contentTypeId = entry.sys.contentType.sys.id;
  let t1;
  if ($[0] !== contentTypeId || $[1] !== experiences) {
    t1 = mapCtaExperiences(experiences, contentTypeId);
    $[0] = contentTypeId;
    $[1] = experiences;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const mappedExperiences = t1;
  if (mappedExperiences.length === 0) {
    let t2;
    if ($[3] !== className || $[4] !== entry) {
      t2 = <CTAButton entry={entry} className={className} />;
      $[3] = className;
      $[4] = entry;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
  let t2;
  if ($[6] !== className) {
    t2 = props => <CTAButtonView {...props} className={className} />;
    $[6] = className;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const view = t2;
  let t3;
  if ($[8] !== entry.fields || $[9] !== entry.sys.id) {
    t3 = {
      id: entry.sys.id,
      fields: entry.fields
    };
    $[8] = entry.fields;
    $[9] = entry.sys.id;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== exposures || $[12] !== mappedExperiences || $[13] !== t3 || $[14] !== view) {
    t4 = <PersonalizedEntry baseline={t3} experiences={mappedExperiences} exposures={exposures} view={view} />;
    $[11] = exposures;
    $[12] = mappedExperiences;
    $[13] = t3;
    $[14] = view;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
}